(() => {
  "use strict";
  var e = {
      d: (t, s) => {
        for (var o in s)
          e.o(s, o) &&
            !e.o(t, o) &&
            Object.defineProperty(t, o, { enumerable: !0, get: s[o] });
      },
      o: (e, t) => Object.prototype.hasOwnProperty.call(e, t),
      r: (e) => {
        "undefined" != typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
          Object.defineProperty(e, "__esModule", { value: !0 });
      },
    },
    t = {};
  e.r(t), e.d(t, { GlobalHeroSlider: () => GlobalHeroSlider });
  class GlobalHeroSlider extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      document.addEventListener(
        `component-initialisation-${this.dataset.compId}`,
        async () => {
          document.dispatchEvent(
            new CustomEvent(`initialisation-confirmed-${this.dataset.compId}`)
          ),
            (this.GlobalHotspotObserver = new ObserverLite({
              key: "Global.HotspotEvents",
            }));
          let e = this.querySelector(":scope > template");
          if (e) {
            try {
              this.settings = JSON.parse(e.innerHTML);
            } catch (e) {
              console.log(e);
            }
            e.remove(), (e = null);
          }
          const t = `global-carousel-${this.dataset.compId}`,
            s = this.querySelector(t);
          await s.ObserverLite.once(),
            (this.emblaApi = s.embla),
            (this.engine = this.emblaApi.internalEngine()),
            (this.controls = this.querySelector(
              ".global-hero-slider__controls"
            )),
            (this.controlsColors = s.dataset.controlsColors.split(",")),
            (this.playButton = this.querySelector(".js-ghs__play"));
          const o = s.plugins?.find(({ type: e }) => "autoplay" == e);
          let l = !1;
          const updatePlayButtonIcon = () => {
              o &&
                (this.playButton.classList.toggle(
                  "global-carousel-nav-btn--paused",
                  l
                ),
                this.playButton.classList.toggle(
                  "global-carousel-nav-btn--play",
                  !l
                ));
            },
            pauseAutoPlay = () => {
              o.pause(), updatePlayButtonIcon();
            },
            invisiblePauseAutoPlay = () => {
              o && o.pause();
            };
          o &&
            this.playButton &&
            this.playButton.addEventListener("click", () => {
              (l = !l), l ? o.pause() : o.play(), updatePlayButtonIcon();
            }),
            Array.from(["init", "reInit", "scroll", "settle"]).forEach((e) =>
              this.emblaApi.on(e, () => {
                this.updateCounter();
              })
            ),
            this.updateCounter(),
            this.emblaApi.on("settle", () => {
              const e = this.engine.index.get(),
                t = this.querySelectorAll(".global-carousel__slide"),
                s = Number(t[e].dataset.slideDelay);
              o.setDelay(s), o && o.paused && l && pauseAutoPlay();
            }),
            (this.nextButton = this.querySelector(".js-ghs__next")),
            (this.prevButton = this.querySelector(".js-ghs__prev")),
            this.nextButton?.addEventListener("click", (e) => {
              e.preventDefault(),
                this.emblaApi.scrollNext(),
                invisiblePauseAutoPlay();
            }),
            this.prevButton?.addEventListener("click", (e) => {
              e.preventDefault(),
                this.emblaApi.scrollPrev(),
                invisiblePauseAutoPlay();
            }),
            this.GlobalHotspotObserver.subscribe(({ event: e }) => {
              "show" === e && o && !o.paused && pauseAutoPlay();
            }),
            this.addEventListener("focusin", () => {
              o && !o.paused && pauseAutoPlay();
            });
        }
      );
    }
    updateCounter() {
      if (
        ((this.count = this.count || this.querySelector(".js-ghs__count")),
        null == this.count)
      )
        return;
      const e = this.emblaApi.slideNodes().length,
        t = this.emblaApi.selectedScrollSnap();
      this.count && (this.count.innerText = `${t + 1} / ${e}`);
      const [s, o] = this.controlsColors[t].split(""),
        l = window.matchMedia("(min-width: 768px)");
      this.controls &&
        this.controls.style &&
        (this.controls.style.filter = `invert(${l.matches ? s : o})`);
    }
  }
  const s = `global-hero-slider-${document.currentScript.dataset.compId}`;
  
  customElements.get(s) || customElements.define(s, GlobalHeroSlider);
  var o = self;
  for (var l in t) o[l] = t[l];
  t.__esModule && Object.defineProperty(o, "__esModule", { value: !0 });
})();
